// extracted by mini-css-extract-plugin
export default {"markdownText":"styles_markdownText__-cvF-"};